// Reliability tier config — shared across the frontend
import { Medal, Trophy, Diamond, Star, Certificate } from "@phosphor-icons/react";

export const TIERS = {
  none: {
    id: "none",
    label: "Unranked",
    tagline: "New to ConnectAPro",
    threshold: 0,
    color: "#5C605E",
    bg: "#E5E2DB",
    Icon: Certificate,
  },
  bronze: {
    id: "bronze",
    label: "Bronze",
    tagline: "Verified starter",
    threshold: 1,
    color: "#FFFFFF",
    bg: "#8B5E34",
    Icon: Medal,
  },
  silver: {
    id: "silver",
    label: "Silver",
    tagline: "Trusted regular",
    threshold: 5,
    color: "#0A0F0D",
    bg: "#C0C0C0",
    Icon: Medal,
  },
  gold: {
    id: "gold",
    label: "Gold",
    tagline: "Community favourite",
    threshold: 15,
    color: "#0A0F0D",
    bg: "#D4AF37",
    Icon: Trophy,
  },
  diamond: {
    id: "diamond",
    label: "Diamond",
    tagline: "Elite performer",
    threshold: 30,
    color: "#FFFFFF",
    bg: "#1D4ED8",
    Icon: Diamond,
  },
  double_platinum: {
    id: "double_platinum",
    label: "Double Platinum",
    tagline: "Truly reliable",
    threshold: 60,
    color: "#FFFFFF",
    bg: "#0A0F0D",
    Icon: Star,
  },
};

export const TIER_ORDER = ["none", "bronze", "silver", "gold", "diamond", "double_platinum"];

export function tierIndex(tierId) {
  const i = TIER_ORDER.indexOf(tierId);
  return i < 0 ? 0 : i;
}

export function nextTier(current) {
  const i = tierIndex(current);
  return TIER_ORDER[i + 1] || null;
}

export function eligibleTier(completedJobs, currentTier) {
  let best = null;
  const currentIdx = tierIndex(currentTier);
  for (const [id, cfg] of Object.entries(TIERS)) {
    if (id === "none") continue;
    if (completedJobs >= cfg.threshold && tierIndex(id) > currentIdx) best = id;
  }
  return best;
}
